export default {
  "content": "<path d=\"M1.134 13.5a1 1 0 001.732 1zm12 1a1 1 0 101.732-1zM11 6a3 3 0 01-3 3v2a5 5 0 005-5zM8 9a3 3 0 01-3-3H3a5 5 0 005 5zM5 6a3 3 0 013-3V1a5 5 0 00-5 5zm3-3a3 3 0 013 3h2a5 5 0 00-5-5zM2.866 14.5C4.156 12.265 6.037 11 8 11V9c-2.891 0-5.34 1.858-6.866 4.5zM8 11c1.963 0 3.843 1.265 5.134 3.5l1.732-1C13.34 10.858 10.892 9 8 9z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};